import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './ContestNav.css';

const ContestNav = ({ selectedTab, onTabClick }) => {
  return (
    <nav className="contest-nav">
      <div className="nav-container">
        <Link
          to="/contests/registering"
          className={`nav-link ${selectedTab === 'registering' ? 'active' : ''}`}
          onClick={() => onTabClick('registering')}
        >
          Registering
        </Link>
        <Link
          to="/contests/running"
          className={`nav-link ${selectedTab === 'running' ? 'active' : ''}`}
          onClick={() => onTabClick('running')}
        >
          Running
        </Link>
        <Link
          to="/contests/completed"
          className={`nav-link ${selectedTab === 'completed' ? 'active' : ''}`}
          onClick={() => onTabClick('completed')}
        >
          Completed
        </Link>
      </div>
    </nav>
  );
};

ContestNav.propTypes = {
  selectedTab: PropTypes.oneOf(['registering', 'running', 'completed']).isRequired,
  onTabClick: PropTypes.func.isRequired
};

export default ContestNav;
